"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getApiBaseUrl = exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _axios = _interopRequireDefault(require("axios"));
var _getNamespace = _interopRequireDefault(require("./getNamespace"));
var _getVersionQuery = _interopRequireDefault(require("./getVersionQuery"));
// eslint-disable-next-line max-statements
var getApiBaseUrl = exports.getApiBaseUrl = function getApiBaseUrl(rootDomain, additionalPath) {
  var proxyBaseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var version = (0, _getVersionQuery.default)('contentApiVersion');
  var prefix = 'modal-loader-api';
  var subdomain;
  var baseUrl = '';
  if (version) {
    if (version === 'local') {
      baseUrl = "https://".concat(prefix, ".local.dev-godaddy.com");
      subdomain = "".concat(prefix, ".local");
    } else {
      baseUrl = "https://".concat(version, ".").concat(prefix, ".").concat(rootDomain);
      subdomain = "".concat(version, ".").concat(prefix);
    }
  } else {
    baseUrl += "https://".concat(prefix, ".").concat(rootDomain);
    subdomain = prefix;
  }
  var path = '/api/v1/';
  if (proxyBaseUrl) {
    return "https://".concat(proxyBaseUrl).concat(path).concat(additionalPath, "?rootDomain=").concat(rootDomain, "&subdomain=").concat(subdomain);
  }
  return "".concat(baseUrl).concat(path).concat(additionalPath);
};
var _default = exports.default = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
    var appConfigKey, namespace, rootDomain, _ref$appProps$proxyBa, proxyBaseUrl, nsData, path, url, resp;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          appConfigKey = _ref.appConfigKey, namespace = _ref.namespace, rootDomain = _ref.rootDomain, _ref$appProps$proxyBa = _ref.appProps.proxyBaseUrl, proxyBaseUrl = _ref$appProps$proxyBa === void 0 ? '' : _ref$appProps$proxyBa;
          nsData = (0, _getNamespace.default)(namespace);
          if (!nsData.appConfig) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", nsData.appConfig);
        case 4:
          path = "appconfig?appKey=".concat(appConfigKey);
          url = "".concat(getApiBaseUrl(rootDomain, path, proxyBaseUrl));
          _context.next = 8;
          return _axios.default.get(url, {
            withCredentials: true
          });
        case 8:
          resp = _context.sent;
          nsData.appConfig = resp.data.appConfig[appConfigKey];
          return _context.abrupt("return", nsData.appConfig);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();